import SimplePage from "@/components/layout/SimplePage";
import RichHtml from "@/components/RichHtml";
import { useContent } from "@/hooks/useContent";

const FALLBACK = `
  <p>Social Action is the heart of how TIOB lives out the Jewish value of <em>tikkun olam</em> &mdash;
     repairing the world. Through volunteering, advocacy, and tzedakah, our Social Action Committee partners
     with local organizations and responds to community needs across Brevard County.</p>
  <h2>What We Do</h2>
  <ul>
    <li><strong>Food-Pantry Assistance.</strong> Our members regularly volunteer to support local food pantries.</li>
    <li><strong>Holiday giving drives.</strong> Toys, school supplies, coats, and Passover groceries.</li>
    <li><strong>Mitzvah days.</strong> Hands-on volunteering at shelters and community gardens.</li>
    <li><strong>Interfaith partnerships.</strong> Building bridges with other Brevard congregations.</li>
  </ul>
  <h2>How to Help</h2>
  <p>To volunteer, donate goods, or suggest a new initiative, contact the temple office at (321) 631-9494 or
     email <a href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a>. Prefer to give financially?
     Your tzedakah is always welcome on our <a href="/donate">donation page</a>.</p>
`;

export default function SocialAction() {
  const { body } = useContent("social_action.body", FALLBACK);
  return (
    <SimplePage
      title="Social Action - All-Inclusive Place of Worship"
      eyebrow="Tikkun Olam"
      subtitle="Repairing the world, one neighbor at a time - at the LGBTQ+ welcoming, all-inclusive Reform synagogue in Brevard County."
      description="Social action and tikkun olam at Temple Israel of Brevard - an all-inclusive, LGBTQ+ welcoming place of worship in Brevard County, FL."
      path="/about/social-action"
      ctaLabel="Get involved"
    >
      <RichHtml html={body} fallback={<div dangerouslySetInnerHTML={{ __html: FALLBACK }} />} />
    </SimplePage>
  );
}
